import { Card, Col, Row, Spin, Empty } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ASIDeviceService } from "../../ducks/asi-devices/asi-devices";
import { useI18n } from "../../i18n/I18nContext";

interface HubCard {
  hubExternalId: string;
  name: string;
  comment?: string;
  asiCount: number;
}

const DevicesHubsPage = () => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [hubs, setHubs] = useState<HubCard[]>([]);
  const [loading, setLoading] = useState(false);
  const service = new ASIDeviceService();

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const data = await service.getHubsOverview();
        setHubs(data || []);
      } catch (e) {
        console.log(e);
        setHubs([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) {
    return <Spin />;
  }

  if (!hubs.length) {
    return <Empty description={t("hubs.empty")} />;
  }

  return (
    <div>
      <h2 style={{ marginBottom: 16 }}>{t("hubs.title")}</h2>
      <Row gutter={[16, 16]}>
        {hubs.map((hub) => (
          <Col xs={24} sm={12} md={8} key={hub.hubExternalId}>
            <Card
              hoverable
              title={hub.name}
              onClick={() =>
                navigate(`/devices/hub/${encodeURIComponent(hub.hubExternalId)}`)
              }
            >
              <div style={{ marginBottom: 8 }}>
                <strong>{t("hubs.comment")}:</strong>{" "}
                {hub.comment || "—"}
              </div>
              <div>
                <strong>{t("hubs.asiCount")}:</strong> {hub.asiCount}
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default DevicesHubsPage;
